module.exports = __webpack_public_path__ + "assets/pdf/mentions-legales-sagae.bdaced25.pdf";